<template>
  <md-bottom-bar class="navi-phone" md-type="shift" md-sync-route>
    <md-bottom-bar-item
      v-for="item in menu"
      :key="item.name"
      :to="item.to"
      :md-icon="require('../assets/'+item.src)"
      :md-label="$t(item.name)"
    />
  </md-bottom-bar>
</template>

<script>
import menu from "../menu.js";
export default {
  name: "Bottom",
  data() {
    return {
      menu: menu
    };
  }
};
</script>

<style lang="scss">
@import "~vue-material/src/components/MdLayout/mixins";

.navi-phone {
  display: none;
  position: fixed;
  bottom: 0;
  z-index: 9;
  @include md-layout-xsmall {
    display: block;
  }
}
</style>